import { render } from "./InitialLoad.vue?vue&type=template&id=0bd519c6&scoped=true&ts=true"
import script from "./InitialLoad.vue?vue&type=script&lang=ts"
export * from "./InitialLoad.vue?vue&type=script&lang=ts"

import "./InitialLoad.vue?vue&type=style&index=0&id=0bd519c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd519c6"]])

export default __exports__